import http from "../helpers/http-common"

class BlockService {

    isPhoneBlocked(phone) {
        const params = {};
        params['phone'] = phone;
        return http.post("/block/isPhoneBlocked", params);
    }

    getBlocks(params) {
        return http.post('/block/all', params);
    }
}

export default new BlockService();